import { render } from "./saleOderDetail.vue?vue&type=template&id=12dc31b2&scoped=true"
import script from "./saleOderDetail.vue?vue&type=script&lang=js"
export * from "./saleOderDetail.vue?vue&type=script&lang=js"

import "./saleOderDetail.vue?vue&type=style&index=0&id=12dc31b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dc31b2"]])

export default __exports__